//natives
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Cookies from 'universal-cookie';
import formatCurrencytoBr from 'format-currency-to-br';
import {Paper,Button,CircularProgress} from '@material-ui/core';
import TagManager from 'react-gtm-module';

//components
import PedidosLista from '../childrens/PedidosLista/.mixins/PedidosLista';
import TabelaDinamica from '../childrens/TabelaDinamica/.mixins/TabelaDinamica';
import ModalFalhaAgendamento from '../childrens/ModalFalhaAgendamento/.mixins/ModalFalhaAgendamento';
import Alerta from '../../../../../util/snackbars/.mixins/';
import Filter from "../../../../../util/filter/.mixins/Filter";
import Paginacao from '../childrens/Paginacao/Paginacao';
import { AuthContext } from '../../../../../../contexts/AuthContext';

//constrollers
import Pedidos_controller from '../../../../../../controllers/pedido';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

export default class Pedidos extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.childPag = React.createRef();
        this.inputRef = React.createRef();
        this.permissions = {};

        this.state = {            
            itens: [],
            size: 'small',
            elevation: 0,
            itensTable: [],
            title: props.route.title,
            columns: this.CheckShowTables(),
            isLoading: true,
            isError: false,
            rowHover: false,
            sort: false,
            error: null,
            fontSize: '8rem',
            responsive: 'stacked',
            rowsPerPage: 7,          
            pagination: false,
            filter: false,
            search: false,
            itemEscolhido: null,
            datasAgendadas: [],
            filters: {
                datas: false,
                flagsPag: false,
                adminFilter: false,
            },
            fornecedor: 0,
            retornoPedidos: [],
            modalFalhaOpen: false,
            totalPagina: null,
            current_page: 1
        }
        
        //binds
        this.setState = this.setState.bind(this);
        this.sendPedido = this.sendPedido.bind(this);
        this.loadData = this.loadData.bind(this);
        
    }

    confirmExit() {
        if (window.datasAgendadas && window.datasAgendadas.length > 0)
            return "Tem certeza que deseja sair dessa página e perder suas seleções de datas que não foram agendadas?";
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:pedidos-pendentes-customizada',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-tela-pedidos-pendentes-customizada',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela Pedidos!");

        window.onbeforeunload = this.confirmExit;

        if (window.datasAgendadas && window.datasAgendadas.length > 0)
            this.setState({datasAgendadas: window.datasAgendadas});
    }

    componentWillUnmount() {
        if (window.datasAgendadas && window.datasAgendadas.length > 0)
            window.location.reload();
    }
    
    async UNSAFE_componentWillMount() {
        this.permissions = this.context.user.permissions;
        
        this.setState({
            filters: {
                ...this.state.filters,
                adminFilter: !!this.permissions["filtro-fornecedor"],
            }
        });
        
        await this.loadPedidos();
        this.setState({
            isLoading: false
        });
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({
            title: this.props.route.title,
            columns: this.CheckShowTables()
        });
        this.loadPedidos();
    }

    CheckShowTables() {
        return [
            {
                name: "Código",
                options: {
                  filter: false,
                  download: false,
                  display: false,
                  viewColumns: false,
                }
            },
            {
                name: "Número",
                options: {
                  filter: false,
                  download: true,
                  display: false,
                  viewColumns: false,
                }
            },
            {
                name: "Descrição Pedido",
                options: {
                  filter: false,
                  download: true,
                  display: false,
                  viewColumns: false,
                }
            },
            {
                name: "Número/Descrição Pedido",
                options: {
                  filter: false,
                  download: false,
                  viewColumns: false,
                  customBodyRender: (value, tableMeta, updateValue) => (
                    <div>
                        <div style={{fontWeight: 'bold'}}>{value.pedido}</div>
                        <div>{value.descricao}</div>
                    </div>
                  )
                }
            },
            "Id Prod", 
            "Cod Numérico",
            "Descrição",
            "Cor",
            // "Rotação",
            "Dt Emis",
            "Dt Orig",
            "Dt Prevista",
            // "Ruptura",
            "Qtd Item",
            "Qtd Entrega",
            "Qtd Pend",
            "Id Fornecedor",
            "Fornecedor",
            "Custo Unit",
            "IPI",
            "Atraso Previsto",
            "Valor Total",
            "Valor Pend",
            "Qtd Volumes Pend",
            "Qtd Agenda",
            "Qtd Volumes Agend",
            "Grupo",
            "Família",
            "Tipo Pedido",
            "Cond Pagamento",
            "Dep Entrega",
            "Código Alfa",
            "%IQ1",
            "NCM",
            "Valor Penalidade (R$)",
            "% Desconto",
            "Valor Desconto (R$)",
            "Valor líquido (Valor R$ total com o desconto aplicado)",
            "Solicitado antecipação (sim/não)",
            {
                name: "PDF Português",
                options: {
                    filter: false,
                    download: false,
                    customBodyRender: (value, tableMeta, updateValue) => (
                        <div>
                            {value &&
                                <Button 
                                    variant="contained" 
                                    color="primary"
                                    onClick={()=>{
                                        this.props.router.push(`/pedidoCompra/${value.CD_FIL}/${value.NR_PC}/${value.LANGUAGE}`);
                                    }}
                                    style={{
                                        padding: 0,
                                        border: 0,
                                        margin: 0
                                    }}
                                >
                                    PDF
                                </Button>
                            }
                        </div>
                    )
                }
            },
            {
              name: "PDF Inglês",
              options: {
                  filter: false,
                  download: false,
                  customBodyRender: (value, tableMeta, updateValue) => (
                      <div>
                          {value &&
                              <Button 
                                  variant="contained" 
                                  color="primary"
                                  onClick={()=>{
                                      this.props.router.push(`/pedidoCompra/${value.CD_FIL}/${value.NR_PC}/${value.LANGUAGE}`);
                                  }}
                                  style={{
                                      padding: 0,
                                      border: 0,
                                      margin: 0
                                  }}
                              >
                                  PDF
                              </Button>
                          }
                      </div>
                  )
              }
          }
        ];
    }

    splitDateString(dateString) {
        return dateString ? dateString.split(' ')[0] : ''
    }

    async loadPedidos() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            let countDe = (this.state.current_page-1)*7;
            let countAte = 7;
            
            const filters = {
                personId: this.state.fornecedor,
                initialRow: countDe,
                nextRows: countAte,
                scheduleIs: 'N',
                retAvailableDates: 'S',
            };

            const r_pedidos = await Pedidos_controller.getPendentesAutomatico(token,filters);
            const j_r_pedidos = JSON.parse(r_pedidos.body);

            if (r_pedidos.res.statusCode === 200) {
                var array = [];
                var id_marc = 0;
                if (j_r_pedidos.length > 0) {
                    this.setState({
                        itens: j_r_pedidos,
                        totalPagina: j_r_pedidos[0].totalRows
                    });
                    j_r_pedidos.forEach(element => {
                        var arrayPush = null;
                        arrayPush = [
                            id_marc,
                            element.purchaseOrderId,
                            element.productName,
                            {pedido: element.purchaseOrderId, descricao: element.productName},
                            element.productId,
                            element.numericCode,
                            element.productName,
                            element.colorAbbreviation,
                            // element.rotation,
                            this.splitDateString(element.issueDate),
                            this.splitDateString(element.deliveryDateOrigin),
                            this.splitDateString(element.expectedDeliveryDate),
                            // element.breakageDescription,
                            element.itemQuantity,
                            element.quantityDelivery,
                            element.quantityOutstanding,
                            element.personId,
                            element.personName,
                            formatCurrencytoBr(element.unitaryValue),
                            element.percentValueIPI,
                            element.forecastQuantity,
                            formatCurrencytoBr(element.amount),
                            formatCurrencytoBr(element.outstandingAmount),
                            element.amountOutstandingVolume,
                            element.scheduleQuantity,
                            element.quantityVolumeSchedule,
                            element.GEPDescription,
                            element.familyId,
                            element.orderTypeDescription,
                            element.paymentId,
                            element.branchDeliveryId,
                            element.alphaId,
                            element.qualityIndex1,
                            element.mercosurCommonName,
                            element.monetaryPenaltySchedule,
                            `${element.percentDiscont}%`,
                            formatCurrencytoBr(element.monetaryDiscont),
                            formatCurrencytoBr(element.netDiscount),
                            element.advanceRequest,
                            {
                            CD_FIL: element.branchId, 
                            NR_PC: element.purchaseOrderId,
                            LANGUAGE: 'PT-BR'
                            },
                            {
                            CD_FIL: element.branchId, 
                            NR_PC: element.purchaseOrderId,
                            LANGUAGE: 'EN'
                            },
                            element.availableScheduleDatesList,
                            element.scheduleAvailabilityDescription
                        ];
                        array.push(arrayPush);
                        id_marc++;
                    });
                }
                this.setState({
                    itensTable:array,
                });
            } else {
                if (
                    j_r_pedidos.status == false && 
                    j_r_pedidos.message && 
                    j_r_pedidos.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:pedidos-pendentes-customizada',
            //       eventAction: 'callback',
            //       eventLabel: `sucesso:lista-pedidos`,
            //     }
            // });

            //auditoria
            var str = "Efetuada requisição para verificação do retorno de pedidos! "
            +"Response:( Method: "+r_pedidos.res.request.method
            +", StatusCode: "+r_pedidos.res.statusCode
            +", Body: (limited 100chars)"+r_pedidos.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            this.child.current?.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:pedidos-pendentes-customizada',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro na recuperação de dados de pedidos! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    async loadData(filters) {
        this.setState({isLoading: true});
        await this.loadPedidos();
        this.setState({isLoading: false});
    }

    async sendPedido() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            this.setState({isLoading: true});

            const data = this.state.datasAgendadas;
            const r_pedido = await Pedidos_controller.postPendentes(token,data,this.state.fornecedor);
            const j_r_pedido = JSON.parse(r_pedido.body);

            this.setState({isLoading: false});
            window.datasAgendadas = [];
            if (r_pedidos.res.statusCode === 200) {

                if (j_r_pedido.retornoPedidos.length > 0) {
                    this.setState({
                        modalFalhaOpen: true,
                        retornoPedidos: j_r_pedido.retornoPedidos
                    });
                } else {
                    this.child.current.retorno(j_r_pedido.message,'success');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            } else {
                if (
                    j_r_pedido.status == false && 
                    j_r_pedido.message && 
                    j_r_pedido.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            var str = "Efetuada requisição para envio de dados de pedido! "
            +"Response:( Method: "+r_pedido.res.request.method
            +", StatusCode: "+r_pedido.res.statusCode
            +", Body: (limited 100chars)"+r_pedido.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            var errorString = "Não foi possivel enviar pedido!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.child.current.retorno(errorString,'error');

            //auditoria
            var str = "Erro no envio de pedidos pendentes! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    render() {
        return(
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Pendentes`}</title>
                </Helmet>
                <Filter {...this}/>
                <br/>
                {this.state.isLoading &&
                    <div align="center">
                        <CircularProgress/>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        <Paper className={'containerTimeline'} style={{marginBottom: 10}}>            
                            <PedidosLista {...this}/>
                            {!this.state.isLoading &&
                                    <div style={{overflowX: 'scroll', zIndex: 1, paddingTop: '0'}}> 
                                        <TabelaDinamica {...this}/>
                                </div>   
                            }
                            
                        </Paper>
                        <div>
                            <Paginacao {...this} ref={this.childPag}/>
                        </div>
                        <br/>
                        {this.state.datasAgendadas.length > 0 &&
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={this.sendPedido}
                                style={{
                                    position:'absolute',
                                    bottom: 30,
                                    right: 30,
                                    margin: '0 auto',
                                    zIndex: 2,
                                }}
                            >
                                Agendar
                            </Button>
                        }
                        <ModalFalhaAgendamento {...this}/>
                    </div>
                }
                <Alerta ref={this.child}/>
            </div>
        );
    }

}